import script from "./CRMCanbanDatatableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMCanbanDatatableActions.vue?vue&type=script&setup=true&lang=js"

import "./CRMCanbanDatatableActions.vue?vue&type=style&index=0&id=29904c14&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29904c14"]])

export default __exports__